<template>
	<div>
		<el-form ref="defForm" :rules="rules" :model="defForm" label-width="80px">
			<el-form-item label="账号" prop="userName">
				<el-input v-model="defForm.userName"></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="passWord">
				<el-input type="passWord" v-model="defForm.passWord"></el-input>
			</el-form-item>
			<el-form-item label="昵称" prop="nickName">
				<el-input v-model="defForm.nickName"></el-input>
			</el-form-item>
			<el-form-item size="large">
				<el-button type="primary" @click="close">取消</el-button>
				<el-button type="primary" :loading="loading" @click="submitForm">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	import {create} from '@/api/user'
	import token from '@/token.js'
	export default {
		name: "Add",
		data() {
			return {
				defForm: {
					roleId: 0,
					admin: 'normal',
					userName: '',
					nickName: '',
					passWord: '',
					createUserID: token.getUser().id,
					createUserName: token.getUser().manager_username
				},
				loading: false,
				rules: {
					userName: [{
						required: true,
						message: '必填项不能为空'
					}],
					passWord: [{
						required: true,
						message: '必填项不能为空'
					}],
				}
			}
		},
		methods: {
			submitForm() {
				// console.log("新增用户",this.defForm)
				this.$refs['defForm'].validate(valid => {
					if (valid) {
						this.loading = true
						create(this.defForm).then(data => {
							this.loading = false
							this.$message.success("管理员["+this.defForm.userName+"]新增成功!")
							this.$refs['defForm'].resetFields()
							this.$emit("after")
							this.$emit("hideDialog")
						}).catch(error => {
							this.loading = false
							this.$message.error(error)
						})
					}
				})
			},
			close() {
				this.$emit("hideDialog")
			}
		}
	}
</script>

<style scoped>

</style>
